/**
 * Algolia configuration for both native and web platforms
 * 
 * For Expo web, environment variables need to be explicitly defined
 * at build time to be available in the browser bundle.
 */

// Platform detection
import { Platform } from 'react-native';

// Try to import Constants, but handle if it's not available
let Constants: any = null;
try {
  Constants = require('expo-constants').default;
} catch (e) {
  console.log('expo-constants not available, using fallback config');
}

// Get config with platform-specific fallbacks
const getAlgoliaAppId = (): string => {
  // For web, use direct env or hardcoded value (expo-constants may not work reliably)
  if (Platform.OS === 'web') {
    return process.env.EXPO_PUBLIC_ALGOLIA_APP_ID || 'DISY4A23YK';
  }
  
  // For native platforms, try Constants first
  return (
    Constants?.expoConfig?.extra?.algolia?.appId ||
    process.env.EXPO_PUBLIC_ALGOLIA_APP_ID ||
    'DISY4A23YK'
  );
};

const getAlgoliaSearchKey = (): string => {
  // For web, use direct env or hardcoded value (expo-constants may not work reliably)
  if (Platform.OS === 'web') {
    return process.env.EXPO_PUBLIC_ALGOLIA_SEARCH_KEY || '3f932c05ba168ee3b52b722a70d57511';
  }
  
  // For native platforms, try Constants first
  return (
    Constants?.expoConfig?.extra?.algolia?.searchKey ||
    process.env.EXPO_PUBLIC_ALGOLIA_SEARCH_KEY ||
    '3f932c05ba168ee3b52b722a70d57511'
  );
};

export const ALGOLIA_CONFIG = {
  appId: getAlgoliaAppId(),
  searchKey: getAlgoliaSearchKey(),
};

// Validate configuration
export function validateAlgoliaConfig() {
  if (!ALGOLIA_CONFIG.appId || !ALGOLIA_CONFIG.searchKey) {
    throw new Error('Algolia configuration is missing. Please check your environment variables.');
  }
  
  if (ALGOLIA_CONFIG.appId === 'YOUR_APP_ID' || ALGOLIA_CONFIG.searchKey === 'YOUR_SEARCH_KEY') {
    throw new Error('Algolia configuration contains placeholder values. Please update with real credentials.');
  }
  
  console.log('✓ Algolia config validated:', {
    appId: ALGOLIA_CONFIG.appId,
    searchKeyLength: ALGOLIA_CONFIG.searchKey.length,
    platform: Platform.OS,
    source: Platform.OS === 'web' ? 'hardcoded/env' : (Constants?.expoConfig?.extra?.algolia ? 'app.json' : 'env vars')
  });
  
  return ALGOLIA_CONFIG;
}
